<div id="instanceDataDialog" 
    appDraggable dragTarget="#instanceDataDialog" dragHandle="#instanceDataDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle locationAlertDataPane"
    style="width:auto; min-width: 450px; max-width: 100%; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
    role="dialog"
    tabindex="-1"
    >

    <div role="document" id="instanceDataDialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="instanceDataDialogHeader">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">x</span>
                </button>
                <h4 class="modal-title">
                    <span>{{ getDialogTitle() }}</span>
                </h4>
            </div>

            <div class="modal-body">
                <ng-container *ngFor="let dataUi of propertyDataUis">
                    <app-property-data-infrastructure
                        [property]="dataUi.mProperty"
                        [data]="dataUi.mData"
                        [isCreate]="false"
                        ></app-property-data-infrastructure>
                </ng-container>


            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="hide()">
                    <i class="fa fa-ban"></i> CANCEL
                </button>
                <button type="button" class="btn btn-primary" (click)="updateData()">
                    <i class="fa fa-refresh"></i> UPDATE
                </button>
            </div>

        </div>
    </div>

</div>